export default __webpack_public_path__ + "static/media/img-0171-spain-full-face.e24d951f.png";